import { lddGlobalSessionInfo } from "../Components/navigationTypes";
import { RPWDataReader } from "../livedataFuncs";

export function copyAttributes(source: RPWDataReader, target: RPWDataReader, attrnames) {
    var arrAttr = (attrnames == null) ? [] : attrnames.split(",");
    for (var i = 0; i < arrAttr.length; i++)
    {
        var attVal = source.getOtherAttribute(arrAttr[i]);
        if (attVal != null) {
            target.setOtherAttribute(arrAttr[i], attVal);
        }
	}
}

export function copyNodes(source: RPWDataReader, target: RPWDataReader, nodeNames) {
    var nodeArr = (nodeNames == null) ? [] : nodeNames.split(",");
    for (var i = 0; i < nodeArr.length; i++) {
        target.exclusiveAppendNodes(nodeArr[i], source.getXMLList(nodeArr[i]));
    }
}

export function FormatStringDataType(value, format)
{
	var retVal = value;
	switch(format)
	{
	case "upper":
		retVal = retVal.toUpperCase();
		break;
	case "lower":
		retVal = retVal.toLowerCase();
		break;
	case "title":
		retVal = retVal.toLowerCase();
		for(var i=0; i<retVal.length; i++)
		{
			if(retVal.charCodeAt(i) >= 97 && retVal.charCodeAt(i) <= 122 && (i === 0 || (retVal.charCodeAt(i-1) < 65 || (retVal.charCodeAt(i-1) > 90 && retVal.charCodeAt(i-1) < 97) || retVal.charCodeAt(i-1) > 122)))
				retVal = retVal.substr(0, i) + String(retVal.charAt(i)).toUpperCase() + retVal.substring(i+1);
		}
		break;
	case "sentance":
		retVal = retVal.toLowerCase();
		var iPos = 0;
		while(iPos < retVal.length && (retVal.charCodeAt(iPos) < 97 || retVal.charCodeAt(iPos) > 122))
			++iPos;
		retVal = retVal.substr(0, iPos) + String(retVal.charAt(iPos)).toUpperCase() + retVal.substring(iPos+1);
		break;
	case "asis":
	default:
		break;
	}
	return retVal;
}

export function TrimFull(theString) {
    theString = nodeToString(theString);
    if (theString == null || theString === "") return theString;
   // if (typeof(theString) == "object" && theString.length == 1) theString = theString[0].xml;
    if (typeof(theString) != "string") return "";
    return RTrimFull(LTrimFull(theString));
}


function LTrimFull(theString) {
    if (theString == null || theString === "") return theString;
    theString = HardSpaceReplace(theString);
    const re = new RegExp("^[ \t\n\r]+", "g");
    return String(theString).replace(re, "");

}

function RTrimFull(theString) {
    if (theString == null || theString === "") return theString;
    theString = HardSpaceReplace(theString);
    const re = new RegExp("[ \t\n\r]+$", "g");
    return String(theString).replace(re, "");
}

function HardSpaceReplace(theString) {
    if (theString == null || theString === "") return theString;
    const re = new RegExp("&#160;", "g");
    return theString.replace(re, " ");
}

function nodeToString(t) {
	if (typeof (t) !== "string" && typeof (t) !== "number") {
		if (t && t.length && t.nextNode) {
			var nodeData = t.nextNode();
			if (nodeData.nodeType === 2)			//attribute
				t = "" + nodeData.nodeValue;		//e.g. @xmlbase on calling GetxmlbaseNode(curNode,xmlbase)
			else if (nodeData.nodeType === 11)	//document fragment
			{
				if (nodeData.childNodes.length === 1 && nodeData.firstChild.nodeType === 3)
					t = "" + nodeData.firstChild.nodeValue;	//most cases
				else
					t = "" + nodeData.text;		//e.g. xsl:if doesn't meet test in xsl:with-param name="fieldvalue", for example, MortgageNumberCharge1
			}
			else
				t = "" + nodeData.text;			//so far, I haven't found this case
		}
		else
			t = "";		//e.g. NO @PaymentAmount when calling function formatData(@PaymentAmount,'money','word')
	}
	if (t == null)
		t = "";
	else
		t = "" + t;
	return t;
}

export function xmlSetAttribute(node,attrName,value,defaultValue)
{
	if (node)
	{
		if (value == null)
			value = defaultValue;
		if (value != null && attrName >"")
			node.setAttribute(attrName,value);	
	}

}

export function getNestedProperty(obj: lddGlobalSessionInfo, path: string){
	return path.split('.').reduce((element, key) => (element ? element[key] : undefined), obj)
}

export function MakeXMLString(str)
{
	var ret = str;
	if(ret && ret !== "")
	{
		ret = ret.replace(/&/g, "&amp;");	//must be the first one
		ret = ret.replace(/"/g, "&quot;");
		ret = ret.replace(/</g, "&lt;");
		ret = ret.replace(/>/g, "&gt;");
	}
	return ret;
}

export function xmlFormatXPathConstant(text)	//in: "abc", out: "'abc'"; in: "Nick's Report", out: "concat('Nick', "'", 's Report')";  
{
	var segByApos = text.split("'");
	if(segByApos.length === 1)
		return "'" + segByApos[0] + "'";

	var retVal = "concat(";
	for(var i=0; i<segByApos.length; i++)
	{
		retVal += "'" + segByApos[i] + "'";
		if(i < segByApos.length - 1)
			retVal += ", \"'\", ";
	}
	retVal += ")";
	return retVal;
}